var _path, _path2, _path3, _path4, _rect, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconObject = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4 9v12M20 9v12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M18 21v-5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M2.75 21.25h18.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M6.5 17.5h5"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 4,
  x: 6.5,
  y: 11.5,
  stroke: "#2F1F19",
  strokeLinejoin: "round",
  rx: 0.5
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3 3.75h18a.25.25 0 0 1 .25.25v4a.25.25 0 0 1-.25.25H3A.25.25 0 0 1 2.75 8V4A.25.25 0 0 1 3 3.75Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M16.5 8.5v-2m3 2v-2m-9 2v-2m3 2v-2m-6 2v-2m-3 2v-2"
})));
export default SvgIconObject;